import React from 'react';
import { FiSend, FiMail, FiUser } from 'react-icons/fi';

const Contact = () => {
  return (
    <section id="contact" className="section bg-dark">
      <div className="container">
        <div className="section-head">
          <h2 className="section-title">Contact</h2>
          <p className="section-sub">Bookings, press, and collaborations.</p>
        </div>
        <form className="contact" aria-label="Contact form" data-reveal>
          <div className="contact-row">
            <div className="field">
              <label htmlFor="name"><FiUser aria-hidden="true" /> Name</label>
              <input id="name" name="name" type="text" placeholder="Your name" />
            </div>
            <div className="field">
              <label htmlFor="email"><FiMail aria-hidden="true" /> Email</label>
              <input id="email" name="email" type="email" placeholder="name@example.com" />
            </div>
          </div>
          <div className="field">
            <label htmlFor="message"><FiSend aria-hidden="true" /> Message</label>
            <textarea id="message" name="message" rows="4" placeholder="How can we work together?" />
          </div>
          <button type="submit" className="btn btn-ghost">
            <FiSend aria-hidden="true" /> Send Message
          </button>
        </form>
      </div>
    </section>
  );
};

export default Contact;
